import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import '../styles/PolicyPages.css';

const Pricing = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <Link to="/" className="back-link">← Back to Home</Link>
        
        <h1 className="policy-title">Pricing</h1>
        <p className="policy-subtitle">Simple, transparent pricing. No subscriptions. No surprises.</p>

        <section className="policy-section pricing-highlight">
          <h2>QuitStick Starter Pack</h2>
          <div className="price-box">
            <div className="price-amount">₹499</div>
            <p className="price-details">(Inclusive of all taxes) — Pack of 5 QuitSticks</p>
          </div>
          <p>Free shipping across India, on every order. No hidden charges. No GST added at checkout.</p>
          <p>Each QuitStick starter pack includes 5 QuitSticks — each one nicotine-free, tobacco-free, and filled entirely with filter fiber. Use one whenever a craving hits. No lighter required. No smoke. No ash.</p>
        </section>

        <section className="policy-section">
          <h2>Why ₹499?</h2>
          <p>We've priced QuitStick to be accessible to every smoker who's serious about quitting. A single pack of cigarettes costs roughly the same — but one pack of QuitSticks helps you build a habit-free life instead of reinforcing one.</p>
        </section>

        <section className="policy-section">
          <h2>Bulk Orders</h2>
          <p>Planning to buy for a group, a workplace wellness program, or a rehabilitation centre? We offer special pricing for bulk orders. Please contact us at <a href="mailto:support@quitstick.in">support@quitstick.in</a> with your requirements and we'll put together a custom quote for you.</p>
        </section>

        <section className="policy-section">
          <h2>Payment Methods</h2>
          <p>We accept all major payment methods including:</p>
          <ul>
            <li>UPI (GPay, PhonePe, Paytm, etc.)</li>
            <li>Debit & Credit Cards (Visa, Mastercard, RuPay)</li>
            <li>Net Banking</li>
            <li>Wallets</li>
          </ul>
          <p>All payments are processed securely. QuitStick does not store your payment information.</p>
        </section>
      </div>
      
      <Footer />
    </div>
  );
};

export default Pricing;
